<!-- Active Filters -->
<div class="active-filters" *ngIf="filters.length > 0">
  <div class="active-filters__title" (click)="onToggle()">
    <i class="fas fa-filter"></i>
    {{'filters.activeFilters' | transloco}}: ({{ filters.length }})
    <i class="fas fa-chevron-down toggle-icon" [class.open]="isOpen"></i>
  </div>
  <div class="active-filters__content" [class.open]="isOpen">
    <div class="active-filters__tag" *ngFor="let filter of filters">
      <div class="active-filters__category">{{ (filter.category) | transloco }}</div>
      <ng-container *ngIf="filter.value.includes('€|jobSalaryPeriods.'); else normalValue">
        <span>{{ filter.value.split('|')[0] }}/{{ (filter.value.split('|')[1]) | transloco }}</span>
      </ng-container>
      <ng-template #normalValue>
        <span>{{ (filter.value) | transloco }}</span>
      </ng-template>
      <button class="remove-btn" (click)="onRemoveFilter(filter)" aria-label="Remove filter"><i class="fas fa-times"></i></button>
    </div>
  </div>
</div>
